import claseReducer from "./claseReducer";
export default claseReducer;